















































































































































































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from "@vue/composition-api";
import { displayRequestStatus } from "@/notifications";
import { Button, Toggle } from "@micad/vue-components/src/main";
import Loading from "@/components/Loading.vue";
import * as nAPI from "@/data/repos/notifications";
import { Notification } from "@/data/repos/notifications";
import { App } from "@/interfaces/common.interfaces";
import {
  SelectOption,
  TableColumn,
} from "@micad/vue-components/src/common/interfaces";
import { find } from "lodash";
import ModalContainer from "@/components/ModalContainer.vue";
import { InputContainer } from "@micad/vue-components";
import { ApiResponse } from "@/data/apiClient";
import { getClientInfo } from "@/data/repos/userInfo";
import DatePicker from "@/components/DatePicker.vue";
import { getApps } from "@/data/repos/apps";
import { canIUse } from "@/modules/auth";

declare global {
  interface Array<T> {
    swap(a: T, b: T): void;
  }
}

Array.prototype.swap = function (a: number, b: number) {
  if (a < 0 || a >= this.length || b < 0 || b >= this.length) return;
  const temp = this[a];
  this[a] = this[b];
  this[b] = temp;
};

const getNotificationStatus = (t: Notification) => "Future" + t.title;

const columns: TableColumn[] = [
  {
    name: "status",
    label: "Status",
    align: "left",
    field: (row: Notification) => getNotificationStatus(row),
    classes: "primary",
    sortable: true,
    showMobile: "",
  },
  {
    name: "title",
    label: "Notification content",
    align: "left",
    field: (row: Notification) => row.title,
    classes: "primary",
    sortable: true,
    showMobile: "",
  },
  {
    name: "date",
    label: "Notification date",
    align: "left",
    field: (row: Notification) => `${row.fromDate} - ${row.toDate}`,
    classes: "primary",
    sortable: true,
    showMobile: "",
  },
  {
    name: "text",
    label: "Notification content",
    align: "left",
    field: (row: Notification) => row.text,
    classes: "primary td-text",
    sortable: true,
    showMobile: "",
  },
  {
    name: "author",
    label: "Author",
    align: "left",
    field: (row: Notification) => row.userTitle,
    classes: "primary",
    sortable: true,
    showMobile: "",
  },
  {
    name: "buttons",
    label: "",
    align: "left",
    field: (row: Notification) => row,
    classes: "primary",
    sortable: false,
    showMobile: "",
  },
];

function customSort(rows: TableColumn[], sortBy: string, descending: boolean) {
  const data = [...rows];

  const column = find(
    columns,
    (c: TableColumn) => c.name == sortBy
  ) as TableColumn;

  if (column && column.sortable && sortBy) {
    data.sort((a, b) => {
      const x = descending ? b : a;
      const y = descending ? a : b;

      let sortByX = column.field(x);
      let sortByY = column.field(y);

      sortByX = String(sortByX).toLowerCase();
      sortByY = String(sortByY).toLowerCase();
      // string sort
      return sortByX > sortByY ? 1 : sortByX < sortByY ? -1 : 0;
    });
  }

  return data;
}

export default defineComponent({
  methods: { canIUse },
  components: {
    DatePicker,
    Button,
    Loading,
    ModalContainer,
    InputContainer,
    Toggle,
  },
  setup() {
    const table = ref(null);
    const showNewDialog = ref(false);
    const notifications = reactive([] as Notification[]);
    const moveUp = async (row: Notification) => {
      state.data.swap(state.data.indexOf(row), state.data.indexOf(row) - 1);
      state.tableKey++;
      await nAPI.reOrderNotifications(state.data, state.app);
    };
    const moveDown = async (row: Notification) => {
      state.data.swap(state.data.indexOf(row), state.data.indexOf(row) + 1);
      state.tableKey++;
      await nAPI.reOrderNotifications(state.data, state.app);
    };
    const addNotification = async () => {
      state.loaded = false;
      let resp: ApiResponse<string>;
      if (state.newNotification.id !== undefined) {
        resp = await nAPI.updateNotification(
          state.newNotificationApp || undefined,
          state.newNotification
        );
        displayRequestStatus(resp, "Notification has been updated");
      } else {
        console.log(JSON.stringify(state.newNotification));
        resp = await nAPI.addNotification(
          state.newNotificationApp,
          state.newNotification
        );
        displayRequestStatus(resp, "Notification has been added");
      }
      if (resp.ok) {
        await fetchNotifications(state.app);
        state.closeNewDialog();
      }
      state.loaded = true;
    };
    const delNotification = async (notification: Notification) => {
      state.loaded = false;
      const resp = await nAPI.deleteNotification(notification.id);
      displayRequestStatus(resp, "Notification has been deleted");
      if (resp.ok) await fetchNotifications(state.app);
      state.loaded = true;
    };
    const state = reactive({
      table,
      showNewDialog,
      showPreviewDialog: false,
      max: 1,
      columns,
      loaded: false,
      historical: false,
      app: "",
      apps: [] as App[],
      appOptions: [] as SelectOption[],
      data: computed((): Notification[] =>
        state.dataRaw.filter((i: Notification) => {
          return state.historical || i.status !== "Past";
        })
      ),
      dataRaw: notifications as Notification[],
      newNotification: {} as Notification,
      fromDate: "",
      toDate: "",
      newNotificationApp: "",
      tableKey: 0,
      pagination: {
        rowsPerPage: 5,
      },
      clientKey: "",
      isTopRow: (row: Notification): boolean => state.data.indexOf(row) === 0,
      isBottomRow: (row: Notification): boolean =>
        state.data.indexOf(row) === notifications.length - 1,
      moveUp,
      moveDown,
      addNotification,
      delNotification,
      editNotification: (notification: Notification): void => {
        Object.assign(state.newNotification, notification);
        state.showNewDialog = true;
      },
      customSort,
      closeNewDialog: (): void => {
        state.newNotification = {} as Notification;
        state.showNewDialog = false;
      },
    });
    watch(
      () => state.app,
      () => fetchNotifications(state.app)
    );

    async function fetchNotifications(app: string) {
      state.loaded = false;
      if (!state.clientKey) state.clientKey = (await getClientInfo()).key;
      const resp = await nAPI.getNotifications(app);
      displayRequestStatus(resp, "", "Failed to load notifications");
      if (resp.ok) {
        notifications.splice(0, notifications.length);
        notifications.push(...(resp.payload || []));
      }
      state.loaded = true;
    }
    watch(
      () => state.app,
      (app: string) => {
        fetchNotifications(app);
        state.newNotificationApp = app;
      },
      { immediate: true }
    );
    setTimeout(async () => {
      state.apps = [
        { id: "", title: "All modules" },
        ...((await getApps()).payload || []),
      ];
      state.appOptions = state.apps.map((o: App) => ({
        label: o.title,
        value: o.id,
      }));
    }, 0);
    return state;
  },
});
